import { render } from "./CardStory.vue?vue&type=template&id=5ff06a36&scoped=true&ts=true"
import script from "./CardStory.vue?vue&type=script&lang=ts"
export * from "./CardStory.vue?vue&type=script&lang=ts"

import "./CardStory.vue?vue&type=style&index=0&id=5ff06a36&scoped=true&lang=scss"

import exportComponent from "/builds/Chirbou/digithia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ff06a36"]])

export default __exports__